//#region src/jsonRpc/network.ts
/**
* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
*/
function getJsonRpcFullnodeUrl(network) {
	switch (network) {
		case "mainnet": return "https://fullnode.mainnet.safecoin.org:443";
		case "testnet": return "https://fullnode.testnet.safecoin.org:443";
		case "devnet": return "https://fullnode.devnet.safecoin.org:443";
		case "localnet": return "http://127.0.0.1:9000";
		default: throw new Error(`Unknown network: ${network}`);
	}
}
//#endregion
export { getJsonRpcFullnodeUrl };

//# sourceMappingURL=network.mjs.map